import _get from 'lodash/get';

export default {
  initSku: (skuType, platformData) => ({
    skuType,
    skuNo: '',
    gtin: '',
    skuName: platformData? platformData.platformProductName: '',
    color: '#ef4f4f',
    patternGuid: 'patten_lipstick_01',
    colorIntensity: 38,
    glossIntensity: 50,
    shimmerIntensity: 50,
    shimmerDensity: 50,
    shimmerColor: '#eeeeee',
    shimmerGranularity: 50,
    image: '',
    shopUrl: '',
    platform: platformData? platformData.platform: '',
    platformPermalink: platformData? platformData.platformPermalink: '',
    platformProductId: platformData? platformData.platformProductId: '',
    enabled: true,
  }),
  fromDb: v => {
    const color = _get(v, 'colors[0]', {});
    return {
      id: v.id ? v.id : v.skuId,
      skuType: v.skuType,
      skuNo: v.skuNo,
      gtin: v.gtin,
      skuName: v.i18n && v.i18n.enu && v.i18n.enu.skuName,
      color: color.colorCode,
      patternGuid:
        v.patterns && !!v.patterns.length && v.patterns[0].patternGuid,
      colorIntensity:
        v.patterns &&
        !!v.patterns.length &&
        parseInt(v.patterns[0].colorIntensities, 10),
      glossIntensity: color.glossIntensity,
      shimmerIntensity: color.shimmerIntensity,
      shimmerDensity: color.shimmerDensity,
      shimmerColor: color.shimmerColorCode || '#eeeeee',
      shimmerGranularity: color.shimmerGranularity,
      imageUrl: v.imageUrl,
      createdTime: v.createdTime,
      lastModified: v.lastModified,
      skuStatus: v.skuStatus,
      enabled: v.skuStatus === 'ENABLED',
      productId: v.productId,
      productNo: v.productNo,
      productName: v.productName,
      shopUrl: v.shopUrl,
      platform: v.platform? v.platform: '',
      platformPermalink: v.platformPermalink,
      platformProductId: v.platformProductId? v.platformProductId: '',
    };
  },
  toDb: v => ({
    sku: {
      id: v.id ? v.id : v.skuId,
      skuType: v.skuType,
      skuNo: v.skuNo,
      skuStatus: v.skuStatus,
      gtin: v.gtin,
      i18n: {
        enu: {
          skuName: v.skuName,
        },
      },
      colors: [
        {
          colorCode: v.color,
          glossIntensity: v.glossIntensity,
          shimmerIntensity: v.shimmerIntensity,
          shimmerDensity: v.shimmerDensity,
          shimmerColorCode: v.shimmerColor,
          shimmerGranularity: v.shimmerGranularity,
        },
      ],
      patterns: [
        {
          patternIndex: 0,
          patternGuid: v.patternGuid,
          colorIndexes: '0',
          colorIntensities: v.colorIntensity,
        },
      ],
      image: v.image,
      imageUrl: v.imageUrl,
      productId: v.productId,
      productNo: v.productNo,
      productName: v.productName,
      shopUrl: v.shopUrl,
      platform: v.platform,
      platformPermalink: v.platformPermalink,
      platformProductId: v.platformProductId,
    },
    enabled: true,
  }),
};
